import { Anchor } from "@mantine/core";
import { OrderResponse } from "types/order.types";

export function getOrderIdLink(order: OrderResponse) {
  const label =
    order.additionalData.label ?? order.externalId ?? `#${order.orderId}`;
  if (order.additionalData.externalLink) {
    return (
      <Anchor href={order.additionalData.externalLink} target="_blank">
        {label}
      </Anchor>
    );
  }
  return label;
}
